import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { auth } from '@/services/firebase';

/**
 * baseUrl (VITE_API_URL) must include env, e.g. http://localhost:3000/develop.
 * API paths are then {resource}/api/v1/... → full URL: {baseUrl}/{resource}/api/v1/...
 */
export const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_URL,
  prepareHeaders: async (headers) => {
    const token = await auth.currentUser?.getIdToken();

    if (token) {
      return headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  }
});
